import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a244f49"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desktop-hotspots" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import gsap from 'gsap'

import { useGameState } from '@/services/composition'
import { Hotspot, useHotspots, useScreenHotspots } from '@/services/stores/hotspots'
import { useDoors } from '@/services/stores/doors'

import DesktopHotspot from '@/components/DesktopHotspot/DesktopHotspot.vue';
import UITemperatureIndicator from '@/components/UITemperatureIndicator/UITemperatureIndicator.vue'
import Viewport from '@/store/modules/Viewport';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n()
const state = useGameState()
const { hotspots, findHotspot } = useHotspots()
const { findHotspot: findScreenHotspot } = useScreenHotspots()
const { findDoor } = useDoors()

const currentHotspots = computed(() => {
  const doneSpots = state.value.context.hotspots
  const isFadeActive = state.value.context.isFadeActive
  return hotspots.filter(hotspot => {
    const screenHotspot = findScreenHotspot(hotspot.id)
    const isDone = doneSpots.includes(hotspot.id)
    return hotspot.states.some(hState => state.value.matches(hState)) && screenHotspot.isVisible && !isDone && !isFadeActive
  }) as Hotspot[]
})

const hotspotHovered = computed(() => {
  return findHotspot(state.value.context.hotspotHovered)
})

const hotspotHoveredPosition = computed(() => {
  return findScreenHotspot(hotspotHovered.value.id).position
})

const hotspotHoveredStyle = computed(() => {
  return { left: `${hotspotHoveredPosition.value[0]}px`, top: `${hotspotHoveredPosition.value[1]}px` }
})

const door = computed(() => {
  if ((!state.value.matches('game') && !state.value.matches('tuto'))) return null

  const id = state.value.context.doorHovered
  if (id === -1) return null

  const door = findDoor(id)
  return door
})

const temperatureIndicatorClass = computed(() => {
  return [door.value?.temperature]
})

const temperatureIndicatorText = computed(() => {
  return t(`game.temperature.${door.value?.temperature}`)
})

const showTemperatureIndicator = computed(() => {
  if (Viewport.isDesktop) {
    return false
  }
  return door.value && hotspotHovered.value && hotspotHovered.value.isDoor
})

const onEnter = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.fromTo(el, { scale: 0 }, { scale: 1, duration: 0.4 })
}

const onLeave = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })
  tl.to(el, { scale: 0, duration: 0.4 })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentHotspots), (h) => {
      return (_openBlock(), _createBlock(DesktopHotspot, {
        key: h.id,
        hotspot: h
      }, null, 8, ["hotspot"]))
    }), 128))
  ]))
}
}

})